import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import styles from "../../styles/styles";
import {
  AiOutlineHeart,
  AiOutlineSearch,
  AiOutlineShoppingCart,
} from "react-icons/ai";
import { IoIosArrowForward } from "react-icons/io";
import { BiMenuAltLeft } from "react-icons/bi";
import { CgProfile } from "react-icons/cg";
import { HiOutlineUserCircle } from "react-icons/hi";
import DropDown from "./DropDown";
import Navbar from "./Navbar";
import { useSelector, useDispatch } from "react-redux";
import { backend_url } from "../../server";
import { getAvatarUrl, getProductImageUrl } from "../../utils/mediaUtils";
import Cart from "../cart/Cart";
import Wishlist from "../Wishlist/Wishlist";
import { RxCross1 } from "react-icons/rx";
import { getRootCategoriesPublic } from "../../redux/actions/category";

const Header = ({ activeHeading }) => {
  const dispatch = useDispatch();
  const { cart } = useSelector((state) => state.cart);
  const { wishlist } = useSelector((state) => state.wishlist);
  const { isAuthenticated, user } = useSelector((state) => state.user);
  const { isSeller, seller } = useSelector((state) => state.seller);
  const { allProducts } = useSelector((state) => state.products);
  const { categories } = useSelector((state) => state.categories);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState(null);
  const [active, setActive] = useState(false);
  const [dropDown, setDropDown] = useState(false);
  const [openCart, setOpenCart] = useState(false);
  const [openWishlist, setOpenWishlist] = useState(false);
  const [open, setOpen] = useState(false);

  const dropdownRef = useRef(null);

  useEffect(() => {
    dispatch(getRootCategoriesPublic());
  }, [dispatch]);

  const rootCategories = categories || [];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropDown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSearchChange = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    const filteredProducts =
      allProducts &&
      allProducts.filter((product) =>
        product.name.toLowerCase().includes(term.toLowerCase())
      );
    setSearchData(filteredProducts);
  };

  useEffect(() => {
    const handleScroll = () => {
      setActive(window.scrollY > 70);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {/* ── Announcement Bar ── */}
      <div className="bg-accent-500 text-black text-xs font-medium py-2 text-center tracking-widest uppercase hidden 800px:block">
        Free shipping on orders above ₹499 &nbsp;|&nbsp; 100% Natural &amp; Authentic Products
      </div>

      {/* ── Main Header (black) ── */}
      <div className="bg-black border-b border-secondary-800">
        <div className={`${styles.section}`}>
          <div className="hidden 800px:flex items-center justify-between py-4 gap-6">

            {/* Logo */}
            <div className="flex-shrink-0">
              <Link to="/" className="flex items-center gap-3">
                <img src="/logo-removebg-preview.png" alt="Positive Moments" className="h-14 scale-110" />
              </Link>
            </div>

            {/* Search Bar */}
            <div className="flex-1 max-w-lg relative">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Search products..."
                  value={searchTerm}
                  onChange={handleSearchChange}
                  className="w-full pl-5 pr-12 py-2.5 bg-secondary-900 border border-secondary-700 rounded-sm text-sm text-white placeholder-secondary-500 focus:outline-none focus:border-accent-500 transition-colors duration-200"
                />
                <button className="absolute right-0 top-0 h-full px-4 bg-accent-500 text-black hover:bg-accent-400 transition-colors">
                  <AiOutlineSearch size={16} />
                </button>
              </div>

              {searchData && searchData.length !== 0 && (
                <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-secondary-200 shadow-xl z-50 max-h-80 overflow-y-auto">
                  {searchData.map((product, index) => (
                    <Link
                      key={index}
                      to={`/product/${product.slug || product._id}`}
                      className="block"
                      onClick={() => setSearchData(null)}
                    >
                      <div className="flex items-center p-3 hover:bg-secondary-50 border-b border-secondary-100 last:border-b-0 transition-colors">
                        <img
                          src={getProductImageUrl(product.images, 0, backend_url)}
                          alt={product.name}
                          className="w-10 h-10 object-cover mr-3"
                        />
                        <div className="flex-1 min-w-0">
                          <h3 className="text-sm font-medium text-gray-900 truncate">{product.name}</h3>
                          <p className="text-xs text-accent-600 font-semibold mt-0.5">
                            ₹{product.discountedPrice || product.price}
                          </p>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              )}
            </div>

            {/* Right Icons */}
            <div className="flex-shrink-0 flex items-center gap-4">
              {/* Wishlist */}
              <button
                className="relative group flex flex-col items-center gap-0.5"
                onClick={() => setOpenWishlist(true)}
              >
                <AiOutlineHeart size={22} className="text-secondary-300 group-hover:text-accent-500 transition-colors" />
                <span className="text-[10px] text-secondary-500 group-hover:text-accent-500 transition-colors uppercase tracking-wider">Wishlist</span>
                {wishlist && wishlist.length > 0 && (
                  <span className="absolute -top-1.5 -right-1.5 bg-accent-500 text-black text-[9px] font-bold rounded-full w-4 h-4 flex items-center justify-center">
                    {wishlist.length}
                  </span>
                )}
              </button>

              {/* Cart */}
              <button
                className="relative group flex flex-col items-center gap-0.5"
                onClick={() => setOpenCart(true)}
              >
                <AiOutlineShoppingCart size={22} className="text-secondary-300 group-hover:text-accent-500 transition-colors" />
                <span className="text-[10px] text-secondary-500 group-hover:text-accent-500 transition-colors uppercase tracking-wider">Cart</span>
                {cart && cart.length > 0 && (
                  <span className="absolute -top-1.5 -right-1.5 bg-accent-500 text-black text-[9px] font-bold rounded-full w-4 h-4 flex items-center justify-center">
                    {cart.length}
                  </span>
                )}
              </button>

              {/* Divider */}
              <div className="w-px h-8 bg-secondary-700" />

              {/* Auth / Seller Profile */}
              {isSeller ? (
                <Link
                  to="/dashboard"
                  className="flex items-center gap-2 text-secondary-300 hover:text-white transition-colors"
                >
                  <img
                    src={getAvatarUrl(seller?.avatar, backend_url)}
                    className="w-8 h-8 rounded-full object-cover border border-secondary-600"
                    alt="Seller Dashboard"
                  />
                  <div className="flex flex-col">
                    <span className="text-[10px] uppercase tracking-wider text-secondary-500 font-semibold text-accent-500">
                      Seller
                    </span>
                    <span className="text-xs font-medium text-white">
                      Dashboard
                    </span>
                  </div>
                </Link>
              ) : isAuthenticated ? (
                <Link
                  to={user?.role === "Admin" ? "/admin/dashboard" : "/profile"}
                  className="flex items-center gap-2 text-secondary-300 hover:text-white transition-colors"
                >
                  <img
                    src={getAvatarUrl(user?.avatar, backend_url)}
                    className="w-8 h-8 rounded-full object-cover border border-secondary-600"
                    alt="Profile"
                  />
                  <div className="flex flex-col">
                    <span className="text-[10px] uppercase tracking-wider text-secondary-500">
                      {user?.role === "Admin" ? "Admin" : "Account"}
                    </span>
                    <span className="text-xs font-medium text-white">
                      {user?.name?.split(" ")[0]}
                    </span>
                  </div>
                </Link>
              ) : (
                <div className="flex items-center gap-3">
                  <Link
                    to="/login"
                    className="text-secondary-300 text-sm font-medium hover:text-white transition-colors uppercase tracking-wider"
                  >
                    Sign In
                  </Link>
                  <Link
                    to="/sign-up"
                    className="px-4 py-2 bg-accent-500 text-black text-sm font-semibold hover:bg-accent-400 transition-colors uppercase tracking-wider"
                  >
                    Register
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* ── Navigation Bar ── */}
      <div
        className={`${
          active
            ? "shadow-lg fixed top-0 left-0 z-50 bg-black border-b border-secondary-800"
            : "bg-secondary-900 border-b border-secondary-800"
        } transition-all duration-200 hidden 800px:block w-full`}
      >
        <div className={`${styles.section}`}>
          <div className="flex items-center justify-between py-2.5">
            {/* Categories */}
            <div className="relative" ref={dropdownRef}>
              <button
                onClick={() => setDropDown(!dropDown)}
                className="flex items-center gap-2 px-4 py-1.5 border border-secondary-700 text-secondary-300 hover:border-accent-500 hover:text-accent-500 text-xs font-medium transition-colors uppercase tracking-widest"
              >
                <BiMenuAltLeft size={16} />
                All Categories
                <IoIosArrowForward className={`transition-transform ml-1 ${dropDown ? "rotate-90" : ""}`} size={12} />
              </button>
              {dropDown && (
                <DropDown categoriesData={rootCategories} setDropDown={setDropDown} />
              )}
            </div>

            {/* Nav Links */}
            <nav className="flex-1 flex items-center justify-center">
              <Navbar active={activeHeading} />
            </nav>

            {/* Right slot (empty or promo) */}
            <div className="text-[11px] text-secondary-500 italic hidden 1000px:block">
              Handcrafted with love ✦
            </div>
          </div>
        </div>
      </div>

      {/* ── Mobile Header ── */}
      <div
        className={`${
          active ? "shadow-lg fixed top-0 left-0 z-50 bg-black" : "bg-black"
        } w-full h-14 border-b border-secondary-800 800px:hidden`}
      >
        <div className="w-full flex items-center justify-between px-4 h-full">
          <BiMenuAltLeft
            size={26}
            className="text-secondary-300 cursor-pointer hover:text-accent-500 transition-colors"
            onClick={() => setOpen(true)}
          />

          <Link to="/" className="flex items-center">
            <img src="/logo-removebg-preview.png" alt="Positive Moments" className="h-8 invert brightness-200" />
          </Link>

          <div className="flex items-center gap-3">
            {isSeller ? (
              <Link to="/dashboard">
                <img
                  src={getAvatarUrl(seller?.avatar, backend_url)}
                  className="w-7 h-7 rounded-full object-cover border border-secondary-600"
                  alt="Seller Dashboard"
                />
              </Link>
            ) : isAuthenticated ? (
              <Link to="/profile">
                <img
                  src={getAvatarUrl(user?.avatar, backend_url)}
                  className="w-7 h-7 rounded-full object-cover border border-secondary-600"
                  alt="Profile"
                />
              </Link>
            ) : (
              <Link to="/login" className="p-1">
                <CgProfile size={22} className="text-secondary-300" />
              </Link>
            )}
            <button
              className="relative p-1"
              onClick={() => setOpenCart(true)}
            >
              <AiOutlineShoppingCart size={22} className="text-secondary-300" />
              {cart && cart.length > 0 && (
                <span className="absolute -top-1 -right-1 bg-accent-500 text-black text-[9px] font-bold rounded-full w-4 h-4 flex items-center justify-center">
                  {cart.length}
                </span>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* ── Mobile Drawer ── */}
      {open && (
        <div
          className="fixed w-full bg-black/60 z-40 h-full top-0 left-0"
          onClick={() => setOpen(false)}
        >
          <div
            className="fixed w-4/5 max-w-sm bg-white h-screen top-0 left-0 z-50 overflow-y-auto shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Drawer Header */}
            <div className="flex items-center justify-between p-4 bg-black">
              <img src="/logo-removebg-preview.png" alt="Positive Moments" className="h-8 invert brightness-200" />
              <RxCross1
                size={20}
                className="text-white cursor-pointer hover:text-accent-500 transition-colors"
                onClick={() => setOpen(false)}
              />
            </div>

            {/* Search */}
            <div className="p-4 border-b border-secondary-100">
              <div className="relative">
                <AiOutlineSearch size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-secondary-400" />
                <input
                  type="search"
                  placeholder="Search products..."
                  className="w-full pl-9 pr-4 py-2 border border-secondary-200 text-sm focus:outline-none focus:border-black"
                  value={searchTerm}
                  onChange={handleSearchChange}
                />
              </div>
              {searchData && searchData.length > 0 && (
                <div className="mt-2 border border-secondary-200 shadow-lg max-h-48 overflow-y-auto">
                  {searchData.map((product, index) => (
                    <Link key={index} to={`/product/${product.slug || product._id}`} onClick={() => { setSearchData(null); setOpen(false); }}>
                      <div className="flex items-center p-2.5 hover:bg-secondary-50 border-b border-secondary-100 last:border-b-0 transition-colors">
                        <img src={getProductImageUrl(product.images, 0, backend_url)} alt={product.name} className="w-8 h-8 object-cover mr-2" />
                        <span className="text-sm text-gray-700 truncate">{product.name}</span>
                      </div>
                    </Link>
                  ))}
                </div>
              )}
            </div>

            {/* Navigation */}
            <div className="p-4 border-b border-secondary-100">
              <p className="text-[10px] uppercase tracking-widest text-secondary-400 font-medium mb-3">Menu</p>
              <Navbar active={activeHeading} />
            </div>

            {/* Wishlist */}
            <div className="p-4 border-b border-secondary-100">
              <div
                className="flex items-center justify-between cursor-pointer hover:text-accent-600 py-2 transition-colors"
                onClick={() => { setOpenWishlist(true); setOpen(false); }}
              >
                <div className="flex items-center gap-3">
                  <AiOutlineHeart size={20} className="text-accent-500" />
                  <span className="text-sm font-medium text-gray-800">My Wishlist</span>
                </div>
                {wishlist && wishlist.length > 0 && (
                  <span className="bg-accent-500 text-black text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                    {wishlist.length}
                  </span>
                )}
              </div>
            </div>

            {/* Profile */}
            <div className="p-4 bg-secondary-50">
              {isSeller ? (
                <div className="flex items-center gap-3">
                  <Link to="/dashboard" onClick={() => setOpen(false)}>
                    <img
                      src={getAvatarUrl(seller?.avatar, backend_url)}
                      alt="Seller Profile"
                      className="w-12 h-12 rounded-full object-cover border-2 border-secondary-200"
                    />
                  </Link>
                  <div>
                    <p className="font-semibold text-gray-900 text-sm">{seller?.name}</p>
                    <Link
                      to="/dashboard"
                      onClick={() => setOpen(false)}
                      className="text-xs text-accent-600 hover:text-accent-700 transition-colors"
                    >
                      Vendor Dashboard →
                    </Link>
                  </div>
                </div>
              ) : isAuthenticated ? (
                <div className="flex items-center gap-3">
                  <Link to="/profile" onClick={() => setOpen(false)}>
                    <img
                      src={getAvatarUrl(user?.avatar, backend_url)}
                      alt="Profile"
                      className="w-12 h-12 rounded-full object-cover border-2 border-secondary-200"
                    />
                  </Link>
                  <div>
                    <p className="font-semibold text-gray-900 text-sm">{user?.name}</p>
                    <Link
                      to="/profile"
                      onClick={() => setOpen(false)}
                      className="text-xs text-accent-600 hover:text-accent-700 transition-colors"
                    >
                      View Profile →
                    </Link>
                  </div>
                </div>
              ) : (
                <div className="space-y-3">
                  <HiOutlineUserCircle size={36} className="text-secondary-300 mx-auto" />
                  <Link
                    to="/login"
                    onClick={() => setOpen(false)}
                    className="block w-full bg-black text-white font-medium py-2.5 text-center text-sm hover:bg-secondary-800 transition-colors"
                  >
                    Sign In
                  </Link>
                  <Link
                    to="/sign-up"
                    onClick={() => setOpen(false)}
                    className="block w-full border border-black text-black font-medium py-2.5 text-center text-sm hover:bg-secondary-50 transition-colors"
                  >
                    Register
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Popups */}
      {openCart && <Cart setOpenCart={setOpenCart} />}
      {openWishlist && <Wishlist setOpenWishlist={setOpenWishlist} />}
    </>
  );
};

export default Header;
